import type { LucideIcon } from 'lucide-react'
import { HeartHandshake, Dna, Swords, MessageSquare } from 'lucide-react'

export type FeatureItem = {
    title: string
    body: string
}

export type FeatureSectionConfig = {
    id: 'adoptions' | 'breeding' | 'quests' | 'forums'
    title: string
    description: string
    icon: LucideIcon
    items: Array<FeatureItem>
}

export const featureSections: Array<FeatureSectionConfig> = [
    {
        id: 'adoptions',
        title: 'Adoptions',
        icon: HeartHandshake,
        description:
            "Users can put up their creatures for adoption or sale. List in the global adoption center for free adoptions, or sell directly to other players. Highlight desirable genes or heritage to attract the right buyers.",
        items: [
            { title: 'Global Adoption Center', body: 'Share or adopt creatures in a community-wide hub.' },
            { title: 'Sell to Players', body: 'List creatures for sale with pricing and details.' },
            { title: 'Showcase Genetics', body: 'Advertise rare traits and unique lineages.' },
        ],
    },
    {
        id: 'breeding',
        title: 'Breeding',
        icon: Dna,
        description:
            "Breed creatures in your realm to generate offspring that combine parental genetics—colors, special genes, and the chance for rare mutations that unlock powerful traits.",
        items: [
            { title: 'Genetics System', body: 'Colors, special genes, inheritance, and mutation chances.' },
            { title: 'Lineage Tracking', body: 'Track ancestry and plan optimal pairings.' },
        ],
    },
    {
        id: 'quests',
        title: 'Quests',
        icon: Swords,
        description:
            'Enter daily quests to level up creatures and earn Mythkcoins and Glimmerstones—used for decorations, food, upgrades, and breeding credits.',
        items: [
            { title: 'Daily Adventures', body: 'Short sessions with scaling rewards and progression.' },
            { title: 'Currencies', body: 'Earn Mythkcoins and Glimmerstones to power your realm.' },
        ],
    },
    {
        id: 'forums',
        title: 'Forums',
        icon: MessageSquare,
        description:
            'Participate in gameplay tips, artwork showcases, roleplay, lore, support, and general discussion. All forums are moderated with age restrictions and posting rules as appropriate.',
        items: [
            { title: 'Gameplay & Tips', body: 'Share strategies, suggestions, and help others.' },
            { title: 'Artwork & Lore', body: 'Showcase personal creations and worldbuilding.' },
            { title: 'Roleplay & Community', body: 'Collaborative storytelling and discussion.' },
        ],
    },
]

